import { Link } from "react-router-dom";
import { Heart, Mail, Phone } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#281520] text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img 
                src="/logo-white.svg" 
                alt="Hope Hospitality Logo" 
                className="w-14 h-14 object-contain"
              />
              <span className="font-serif text-xl font-bold">Hope Hospitality</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Providing comfort and support to families of hospital patients through 
              lodging, transportation, and daily necessities.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-white/70 hover:text-white transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/hotel-partners" className="text-white/70 hover:text-white transition-colors text-sm">
                  Hotel Partners
                </Link>
              </li>
              <li>
                <Link to="/hospital-partners" className="text-white/70 hover:text-white transition-colors text-sm">
                  Hospital Partners
                </Link>
              </li>
              <li>
                <Link to="/donate" className="text-white/70 hover:text-white transition-colors text-sm">
                  Donate
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif font-bold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/70 text-sm">
                <Mail className="w-4 h-4" />
                info@hopehospitality.org
              </li>
              <li className="flex items-center gap-3 text-white/70 text-sm">
                <Phone className="w-4 h-4" />
                (435) 619-9811
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-serif font-bold text-lg mb-4">Support Our Mission</h4>
            <p className="text-white/70 text-sm mb-4">
              Your donation helps families stay close to their loved ones during difficult times.
            </p>
            <Link 
              to="/donate" 
              className="inline-flex items-center gap-2 bg-accent hover:bg-accent/90 text-accent-foreground px-6 py-3 rounded-full text-sm font-medium transition-colors"
              data-testid="footer-donate-button"
            >
              <Heart className="w-4 h-4" />
              Donate Now
            </Link>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Hope Hospitality. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/admin" className="text-white/50 hover:text-white/70 text-sm transition-colors">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
